import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
let diagnosis = class diagnosis extends Vue {
  constructor() {
    super(...arguments);
    this.answer = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  // get questionnaireType() {
  //   return QuestionnaireEditModule.questionnaireType;
  // }
  get getColorForAnswer() {
    if (this.zItem.answered) {
      if (this.zItem.rightAnswer) {
        return "type_green";
      } else if (this.zItem.rightAnswer === null) {
        return "type_yellow";
      } else {
        return "red";
      }
    } else {
      return "c999";
    }
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], diagnosis.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], diagnosis.prototype, "zIndex", void 0);
__decorate([Prop({
  type: String,
  default: "QUESTIONNAIRE"
})], diagnosis.prototype, "questionnaireType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], diagnosis.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], diagnosis.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], diagnosis.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], diagnosis.prototype, "dataChage", null);
diagnosis = __decorate([Component({
  name: "s"
})], diagnosis);
export default diagnosis;